<template>
  <div class="contatiner">
    <!-- <div class="mian-box">
      <div class="title">设置文件过期时间</div>
      <el-input
        style="width: 200px;"
        v-model="fileExpiryDays"
        placeholder="请输入"
      >
      </el-input>
      <span style="margin-left: 6px;">天</span>
    </div> -->

    <el-form :model="form" label-width="auto" style="max-width: 800px;">
      <el-form-item label="设置文件过期时间">
        <div class="form-item">
          <el-input v-model="form.fileExpiryDays" placeholder="请输入"/>
          <span class="unit">天</span>
        </div>
      </el-form-item>

      <el-form-item label="重新编辑超时时间">
        <div class="form-item">
          <el-input v-model.number="form.messageReEditTime" placeholder="请输入" />
          <span class="unit">分钟</span>
        </div>
      </el-form-item>

      <el-form-item label="撤回超时时间">
        <div class="form-item">
          <el-input v-model.number="form.cancelMessageTimeout" placeholder="请输入" />
          <span class="unit">分钟</span>
        </div>
      </el-form-item>
       <el-form-item label="设置消息编辑超时时间">
        <div class="form-item">
          <el-input v-model.number="form.messageEditTime" placeholder="请输入" />
          <span class="unit">分钟</span>
        </div>
      </el-form-item>
       <el-form-item label="设置合并消息转发层级">
        <div class="form-item">
          <el-input v-model.number="form.combineForwardLayersOverLimit" placeholder="请输入" />
          <span class="unit">层级</span>
        </div>
      </el-form-item>
      <el-form-item label="设置消息编辑次数">
        <div class="form-item">
          <el-input v-model.number="form.messageEditCount" placeholder="请输入" />
          <span class="unit">次</span>
        </div>
      </el-form-item>
      <el-form-item label="设置消息删除时间(单聊)">
        <div class="form-item">
          <el-input v-model.number="form.messageDeleteTime" placeholder="请输入" />
          <span class="unit">分钟</span>
        </div>
      </el-form-item>
      <el-form-item label="设置消息删除时间(群聊)">
        <div class="form-item">
          <el-input v-model.number="form.messageDeleteTimeForGroup" placeholder="请输入" />
          <span class="unit">分钟</span>
        </div>
      </el-form-item>
    </el-form>
    <div class="btn-box">
      <el-button type="primary" @click="confirm">确认</el-button>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import ApplicationService from '../../services/applicationService';
import { ElMessage } from 'element-plus';
import ErrorCode from '@/constants/ErrorCode';
import { useRoute } from 'vue-router'
const route = useRoute()

// const fileExpiryDays = ref(null)
const form = ref({
  appId: route.params.appId,
  fileExpiryDays: null,
  messageReEditTime: null,
  cancelMessageTimeout: null,
  messageEditTime: null,
  combineForwardLayersOverLimit: null,
  messageEditCount: null,
  messageDeleteTime: null,
  messageDeleteTimeForGroup: null,
})

const confirm = () => {
  form.value.appId = route.params.appId;
  let appSettings = {
    appId: route.params.appId,
    fileExpiryDays: form.value.fileExpiryDays == null || form.value.fileExpiryDays == undefined ? null : Number(form.value.fileExpiryDays || '14'),
    messageReEditTime: form.value.messageReEditTime == null || form.value.messageReEditTime == undefined ? null : Number(form.value.messageReEditTime || 30),
    cancelMessageTimeout: form.value.cancelMessageTimeout == null || form.value.cancelMessageTimeout == undefined ? null : Number(form.value.cancelMessageTimeout || 1440),
    messageEditTime: form.value.messageEditTime == null || form.value.messageEditTime == undefined ? null : Number(form.value.messageEditTime || 30),
    combineForwardLayersOverLimit: form.value.combineForwardLayersOverLimit == null || form.value.combineForwardLayersOverLimit == undefined ? null : Number(form.value.combineForwardLayersOverLimit || 3),
    messageEditCount: form.value.messageEditCount == null || form.value.messageEditCount == undefined ? null : Number(form.value.messageEditCount || 1),
    messageDeleteTime: form.value.messageDeleteTime == null || form.value.messageDeleteTime == undefined ? null : Number(form.value.messageDeleteTime || 30),
    messageDeleteTimeForGroup: form.value.messageDeleteTimeForGroup == null || form.value.messageDeleteTimeForGroup == undefined ? null : Number(form.value.messageDeleteTimeForGroup || 30),
   };
  ApplicationService.appSeting(appSettings).then(response=> {
    if (response.code === ErrorCode.Success) {
      ElMessage.success('操作成功!');
    }else {
      ElMessage.error(response.msg);
    }
  })
}

const init = () => {
  ApplicationService.getAppSeting(route.params.appId).then(res=> {
    if (res.code === ErrorCode.Success) {
      form.value = res.data || {}
    }
  })
}

onMounted(()=> {
  init()
})
</script>

<style scoped>
.contatiner {
  padding: 40px;
}


.form-item {
  display: flex;
}
.unit {
  width: 40px;
  color: #606266;
  margin-left: 6px;
}

/* .title {
  font-weight: bold;
  color: #606266;
  margin-right: 12px;
} */

.btn-box {
  margin-top: 100px;
  display: flex;
  justify-content: center;
}

</style>
